import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import posthog from 'posthog-js';
/**
 * PostHog Analytics Setup
 *
 * MANUAL STEPS REQUIRED IN POSTHOG DASHBOARD:
 *
 * 1. Add Authorized Domain:
 *    - Go to Settings → Project → Web Analytics Domains
 *    - Click "Add new authorized URL"
 *    - Enter: https://sudalash.com
 *    - Save
 *
 * 2. Verify Events:
 *    - Go to Install → Verify Installation
 *    - Check "Waiting for events" section
 *    - Events should appear after navigating your site
 *
 * 3. Optional Features (Settings → Project):
 *    - Autocapture & heatmaps: Enable if desired
 *    - Session replay: Enable recording and choose masking level
 *    - Web vitals: Enable to capture CLS, FCP, LCP, INP
 *    - Cookieless mode: Enable for privacy-preserving tracking
 *
 * 4. Test in Browser Console:
 *    posthog.capture('my event', { check: 'manual' })
 */
// Initialize PostHog early - before React renders
posthog.init('phc_UKwVaoII4GOfaiyy7gxjw1bqeBXQalUbYMb9HShwRea', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only',
  // Automatic event capture
  capture_pageview: true,
  capture_pageleave: true,
  // Privacy settings
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '[data-private]' // Mask elements with data-private attribute
  },
  // Performance and debugging
  loaded: posthog => {
    // Verify PostHog loaded successfully
    console.log('PostHog initialized successfully');
    // Optional: Disable in development
    // if (process.env.NODE_ENV === 'development') {
    //   posthog.opt_out_capturing()
    //   console.log('PostHog tracking disabled in development')
    // }
  },
  // Autocapture settings (can also be configured in dashboard)
  autocapture: {
    dom_event_allowlist: ['click', 'submit', 'change'],
    url_allowlist: ['sudalash.com'] // Only capture on your domain
  }
});
render(<App data-id="element-885" />, document.getElementById('root'));